import GoogleMapReact from "google-map-react";

import publicConfig from "config/public";

type MapProps = {
  location: {
    lon: number;
    lat: number;
  };
};

const Map = ({ location }: MapProps) => {
  const { lat, lon } = location;

  const center = { lat: lat, lng: lon };
  const zoom = 14;
  const options = {
    backgroundColor: "#f6f6f6",
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    draggable: false,
    gestureHandling: "none",
    keyboardShortcuts: false,
    scrollwheel: false,
    styles: [
      {
        elementType: "all",
        featureType: "administrative",
        stylers: [
          { hue: "#0060ff" },
          { lightness: -100 },
          { visibility: "off" },
          { saturation: "-77" },
        ],
      },
      {
        elementType: "labels.text.fill",
        featureType: "administrative",
        stylers: [{ visibility: "on" }, { color: "#848ea4" }],
      },
      {
        elementType: "geometry",
        featureType: "landscape",
        stylers: [
          { hue: "#0060ff" },
          { saturation: "-70" },
          { lightness: "0" },
          { visibility: "on" },
        ],
      },
      {
        elementType: "geometry.fill",
        featureType: "landscape",
        stylers: [{ hue: "#0050ff" }, { saturation: "0" }, { lightness: "0" }],
      },
      {
        elementType: "labels",
        featureType: "landscape",
        stylers: [
          { hue: "#0060ff" },
          { saturation: "-80" },
          { lightness: "-90" },
          { visibility: "off" },
        ],
      },
      {
        elementType: "all",
        featureType: "poi",
        stylers: [
          { hue: "#0060ff" },
          { saturation: "-80" },
          { lightness: "-70" },
          { visibility: "off" },
          { gamma: "1" },
        ],
      },
      {
        elementType: "geometry",
        featureType: "road",
        stylers: [
          { hue: "#0060ff" },
          { saturation: "-85" },
          { lightness: "60" },
          { visibility: "on" },
        ],
      },
      {
        elementType: "labels",
        featureType: "road",
        stylers: [
          { hue: "#0060ff" },
          { saturation: "-70" },
          { lightness: "50" },
          { visibility: "off" },
        ],
      },
      {
        elementType: "all",
        featureType: "road.local",
        stylers: [
          { hue: "#0060ff" },
          { saturation: "0" },
          { lightness: "-11" },
          { visibility: "on" },
        ],
      },
      {
        elementType: "geometry",
        featureType: "transit",
        stylers: [
          {
            visibility: "simplified",
          },
          { hue: "#0060ff" },
          { lightness: "0" },
          { saturation: "0" },
        ],
      },
      {
        elementType: "labels",
        featureType: "transit",
        stylers: [
          { hue: "#0060ff" },
          { lightness: -100 },
          { visibility: "off" },
        ],
      },
      {
        elementType: "geometry",
        featureType: "water",
        stylers: [
          { hue: "#0066ff" },
          { saturation: "0" },
          { lightness: 100 },
          { visibility: "on" },
        ],
      },
      {
        elementType: "labels",
        featureType: "water",
        stylers: [
          { hue: "#000000" },
          { saturation: -100 },
          { lightness: -100 },
          { visibility: "off" },
        ],
      },
    ],
  };

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: publicConfig.googleMapsApiKey,
      }}
      center={center}
      zoom={zoom}
      options={options}
    >
      <div className="map-marker map-marker--md" />
    </GoogleMapReact>
  );
};
export default Map;
